<template>
  <div id="messages" class="clearfix notosans px2 mb4">
    <div class="col-12">
      <div class="clearfix">
        <div class="col-12 mt2 px0 flex justify-between items-center">
          <p class="h4 semi-bold line-height-2 mt1">Indbakke</p>
        </div>
        <div v-if="loading">
          <Loading></Loading>
        </div>
        <div class="flex xs-hide" v-else>
          <div class="col-5 pl0 pr3">
            <el-tabs id="inboxsent" v-model="activeNameInboxSent" @tab-click="handleToggleInboxSent">
              <el-tab-pane label="Indbakke" name="inbox">
                <div class="py2 highlights">
                  <div>
                    <div class="mb2 flex col-12 items-center p0">
                      <p class="h6 m0 p0 flex"> 
                        <span class="">Alle meddelelser </span>
                        <span class="p1 white darkblue-background ml1">{{parseInt(totalmessages)}}</span>
                      </p>
                      <!-- <div class="ml-auto flex">
                        <button class="dark-button p1 font14 mr1" @click="Shownewmessages()"><span class="">Nye beskeder</span></button>
                        <button class="dark-button p1 font14 " @click="showoldmessages()"><span class="">Gamle beskeder</span></button>
                      </div> -->
                    </div>
                    <div class="flex mb1" id="searchmessages">
                      <div class="col-9 p0 m0">
                        <div class="flex justify-between border items-center mb3">
                          <div class="inline-block h4 line-height-1 m0 p0 mx2"><i class="easternblue el-icon-search"></i>
                          </div>
                          <input v-model="searchQuery" placeholder="Søg i beskeder" type="text" style="height: 45px;"
                            class="h6 book darkblue border-none not-rounded line-height-1 m0 py2 pr0 col-10">
                        </div>
                      </div>
                      <div class="col-3 p0">
                        <button type="button"
                          class="col-12 block action-button button-padding border-none not-rounded font14 regular line-height-1 py2 px1" @click="composeFormVisible = true">
                          <span>Ny email <i class="el-icon-circle-plus-outline"></i></span>
                        </button>
                      </div>
                    </div>
                    <div v-if="paginationLoading" style="height:600px;">
                      <Loading></Loading>
                    </div>
                    <el-tabs id="oldmessagestoggle" v-model="activeName" v-else>
                      <el-tab-pane label="Nye beskeder" name="new">
                        <div class="overflow-auto" style="height: 650px;">
                          <div v-if="resultQuery && resultQuery.length > 0 && messagesData != null && messagesData.length > 0">
                            <!-- eslint-disable -->
                            <div
                              :class="'flex border secondarycolor-border p2 pointer msgItem mail-'+ msgs.ID +' seen-' + msgs.SEEN + ' fromPartner-' + msgs.IS_FROM_PARTNER"
                              v-for="(msgs, index) in resultQuery" @click="getMessageDetails(msgs.ID, msgs.THREAD_ID, msgs)">
                              <div class="col-2 p0">
                                <img :src="msgs.IS_FROM_PARTNER ? msgs.PARTNER.AVATAR : msgs.CONTACT.AVATAR" width="50"
                                  height="50" class="rounded-circle border">
                              </div>
                              <div class="col-10 p0 flex justify-between">
                                <div class="col-10 p0">
                                  <div class="flex flex-wrap justify-between">
                                    <span class="h5 darkblue block">{{msgs.IS_FROM_PARTNER ? msgs.PARTNER.NAME : msgs.CONTACT.NAME}}</span>
                                    <span class="font14 regular rounded mb0 h6 line-height-1 regular darkblue-background p1 white inline-block mb2" v-if="msgs.PROJECT != null">{{msgs.PROJECT.NAME}}</span>
                                  </div>
                                  <span class="h6 darkblue block">{{msgs.TITLE.length >= 40 ? msgs.TITLE.substring(0, 40) + '...' : msgs.TITLE}}</span>
                                  <span class="font14 regular mediumgrey block m0" v-html="msgs.MESSAGE.length >= 55 ? msgs.MESSAGE.replace(/\<br\>/g,' ').substring(0, 55) + '...' : msgs.MESSAGE.replace(/\<br\>/g,' ')"></span>
                                </div>
                                <div class="col-2 p0">
                                  <p class="small regular m0 mediumgrey text-right">{{moment(msgs.SEND_DATE).fromNow()}}</p>
                                </div>
                              </div>
                            </div>
                            <!-- eslint-enable -->
                          </div>
                          <div v-else>
                            <div class="mb4"></div>
                            <div class="flex justify-center items-center">
                              <span class="mr2"><i class="h1 menu-icon-mail"></i></span>
                              <p class="h5 center regular easternblue m0 p0">Ingen beskeder</p>
                            </div>
                          </div>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane label="Gamle beskeder" name="old">
                        <div class="right-align">
                          <router-link to="/email" class="primarycolor">E-mail</router-link>
                        </div>
                        <div class="py2 inboxSpecial overflow-auto" style="height:710px;">
                          <b-tabs v-model="tabIndex" pills>
                            <b-tab>
                              <template #title>
                                <span class='el-icon-download mr1' ></span><span class='gibson'>Inbox</span>
                              </template>
                              <div class="messages notosans">
                                <b-alert class="col-12 px0 primarycolor flex justify-start items-center" :show="showDismissibleAlert">
                                  <div class="relative" style="top:3px;">
                                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-inbox-f"><path d='M20 5H0l4-5h12l4 5zm0 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h6.126a4.002 4.002 0 0 0 7.748 0H20zM8.265 7h3.465a2 2 0 0 1-3.465 0z' /></svg>
                                  </div>
                                  <div class="px2">Din indbakke er tom</div>
                                </b-alert>
                                <Message v-for="(email, index) in emails" @showItemDetails="showItemDetails" :email="email" :starMessage="starMessage" :key="index">
                                </Message>
                              </div>
                            </b-tab>
                          </b-tabs>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                    <div class="my2 flex col-12 p0">
                      <el-pagination class="ml-auto" background layout="prev, pager, next" :page-size="perPage" @current-change="paginationChanged" :total="this.totalitems">
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="Sendt" name="sent">
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="col-7 p3 highlights overflow-auto" style="height:860px;">
            <div class="clearfix" v-if="messageDetailsLoading">
              <Loading></Loading>
            </div>
            <div v-else>
              <div v-if="messageDetailsVisible">
                <div class="flex mb4" v-if="messageDetailsData.length > 0">
                  <span class="h2 darkblue mr2">{{messageDetailsData[0].TITLE}}</span>
                  <span class="h6 regular rounded mb0 h6 line-height-1 regular darkblue-background p1 white inline-block mb2"
                    v-if="messageDetailsData[0].PROJECT != null">{{messageDetailsData[0].PROJECT.NAME}}
                  </span>
                </div>
                <el-collapse v-model="activeCollapse" class="mb4">
                  <el-collapse-item class="msg-thread mb3" :id="msg.IS_FROM_PARTNER ? 'userId-' + msg.PARTNER_ID : 'userId-' + msg.CONTACT_ID" :name="msg.ID"
                    v-for="(msg, index0) in messageDetailsData" :key="index0">
                    <template slot="title">
                      <div class="flex justify-between items-center col-12 p0 mb2">
                        <div class="flex justify-between items-center mr1">
                          <img :src="msg.IS_FROM_PARTNER ? msg.PARTNER.AVATAR : msg.CONTACT.AVATAR" class="rounded-circle mr1" alt="avatar" width="50" height="50">
                          <p class="h5 regular shakespeare m0 line-height-4">{{msg.IS_FROM_PARTNER ? msg.PARTNER.NAME : msg.CONTACT.NAME}}</p>
                        </div>
                        <div>
                          <p class="regular mediumgrey line-height-1 m0">
                            <span class="capital">{{moment(msg.SEND_DATE).locale('da').format('LL')}}</span>
                            ({{moment(msg.SEND_DATE).fromNow()}})
                          </p>
                        </div>
                      </div>
                    </template>
                    <div class="h6 regular line-height-golden mediumgrey mb2" v-html="msg.MESSAGE"></div>
                    <div class="flex flex-wrap col-12 m0 p0" v-if="msg.ACTIONS && !msg.ACTIONS.IS_DONE">
                      <button  class="action-button button-padding border-none not-rounded h5 capital regular line-height-1 p1 mr1 mb2" style="height: 54px;" @click="createPayProfFormVisible = true" v-if="!hasAPayProffAccount">
                        <span class="capitalize">Create Payproff Account</span>
                      </button>
                      <div :id="'btnAction-' + msg.ID" :class="'mb3 isDone-' + msg.ACTIONS.IS_DONE" v-if="!msg.IS_FROM_PARTNER">
                        <!-- eslint-disable -->
                        <el-tooltip :content="btnAction.ACTION.replaceAll('_', ' ').toUpperCase()" placement="top" effect="light" v-for="(btnAction, index) in msg.ACTIONS.ITEMS" :key="index">
                          <a type="button" :href="btnAction.DATA" class="action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2 no-underline" v-if="btnAction.ACTION === 'edit_contract'">
                            <span class=""><i class="el-icon-document"></i></span>
                          </a>
                          <a type="button" :href="'#' + btnAction.DATA.split('#')[1]" class="action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2 no-underline" v-else-if="btnAction.ACTION === 'edit_extra_work'">
                            <span class="">Ny aftale seddel</span>
                          </a>
                          <a type="button" :href="'#' + btnAction.DATA.split('#')[1]" class="action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2 no-underline" v-else-if="btnAction.ACTION === 'view_deficiency'">
                            <span class="">{{btnAction.TITLE_DK}}</span>
                          </a>
                          <button type="button" class="action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2" @click="submitActionButton(msg.ID, btnAction.ACTION, btnAction.DATA)" v-else>
                            <span class="" v-if="btnAction.ACTION == 'bank_payment'"><i class="el-icon-bank-card"></i></span>
                            <span class="" v-else-if="btnAction.ACTION == 'rate_partner'"><i class="el-icon-star-off"></i></span>
                            <!-- <span class="" v-if="index == 0"><i class="el-icon-download"></i></span>
                            <span class="" v-else-if="index == 1"><i class="el-icon-check"></i></span>
                            <span class="" v-else-if="index == 2"><i class="el-icon-close"></i></span>
                            <span class="" v-else-if="index == 3"><i class="el-icon-edit"></i></span> -->
                          </button>
                        </el-tooltip>
                        <!-- eslint-enable -->
                      </div>
                    </div>
                    <div class="mb3" v-if="msg.FILES.length > 0">
                      <a target="_blank" :href="file" class="block" v-for="(file, index) in msg.FILE" :key="index">{{file.replace($http.options.root.slice(0, -2) + 'upload/partner/messages/', '')}}</a>
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <div>
                  <wysiwyg placeholder="Notat" class="mb2" required v-model="replyForm.message" />
                  <button type="button"
                    class="col-2 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1"
                    @click="sendMessage('reply')">
                    <span>Send</span>
                  </button>
                </div>
              </div>
              <div class="center py2" v-else>
                <span class="h5">Vælg en besked, der skal vises</span>
              </div>
            </div>
          </div>
        </div>
        <!-- start mobile view -->
        <div class="sm-hide lg-hide md-hide xxl-hide">
          <div class="col-12 p0">
            <div class="flex justify-between border items-center mb3">
              <div class="inline-block h4 line-height-1 m0 p0 mx2"><i class="easternblue el-icon-search"></i></div>
              <input v-model="searchQuery" placeholder="Søg i beskeder" type="text"
                class="h6 book gibson darkblue border-none not-rounded line-height-1 m0 py2 pr0 col-10">
            </div>
            <div class="mb2 flex col-12 items-center p0">
              <p class="h5 m0 p0"> Alle meddelelser <span class="border p1 white darkblue-background">{{Number(totalmessages)}}</span> </p>
              <!-- <div class="ml-auto">
                <button class="dark-button p1 mx1" @click="Shownewmessages()"><span class="">Ny</span></button>
                <button class="dark-button p1 " @click="showoldmessages()"><span class="">Gammel</span></button>
              </div> -->
            </div>
            <div v-if="paginationLoading">
              <Loading></Loading>
            </div>
            <el-tabs v-model="activeName" v-else>
              <el-tab-pane label="Nye beskeder" name="new">
                <el-collapse v-model="activeNames" @change="handleChange" accordion>
                  <el-collapse-item :name="msgs.ID+'-'+msgs.THREAD_ID" v-for=" (msgs) in resultQuery" :key="msgs.ID"
                    :class="'border secondarycolor-border p1 pointer msgItem mail-'+ msgs.ID +' seen-' + msgs.SEEN + ' fromPartner-' + msgs.IS_FROM_PARTNER"
                    @click="getMessageDetails(msgs.ID, msgs.THREAD_ID, msgs)">
                    <template slot="title">
                      <div class="col-2 p0">
                        <img :src="msgs.IS_FROM_PARTNER ? msgs.PARTNER.AVATAR : msgs.CONTACT.AVATAR" width="50" height="50"
                          class="rounded-circle border messageavatar">
                      </div>
                      <div class="col-10 p0 flex items-center">
                        <div class="col-4 p0">
                          <div class="flex flex-wrap justify-between">
                            <span class="h6 darkblue block">{{(msgs.IS_FROM_PARTNER ? msgs.PARTNER.NAME : msgs.CONTACT.NAME) | truncate(10, '..')}}</span>
                          </div>
                        </div>
                        <div class="col-6 p0 flex items-center">
                          <span class="h6 regular rounded mb0 h6 line-height-1 regular darkblue-background p1 white inline-block"
                            v-if="msgs.PROJECT != null">{{msgs.PROJECT.NAME | truncate(25, '..')}}</span>
                        </div>
                        <div class="col-2 p0">
                          <p class="small regular m0 mediumgrey text-right">{{moment(msgs.SEND_DATE).fromNow()}}</p>
                        </div>
                      </div>
                    </template>
                    <div class="p3 highlights">
                      <div class="clearfix" v-if="messageDetailsLoading">
                        <Loading></Loading>
                      </div>
                      <div v-else>
                        <div v-if="messageDetailsVisible">
                          <el-collapse v-model="activeCollapse" class="mb4">
                            <el-collapse-item class="msg-thread mb3" :id="msg.IS_FROM_PARTNER ? 'userId-' + msg.PARTNER_ID : 'userId-' + msg.CONTACT_ID" :name="msg.ID"
                              v-for="(msg, index0) in messageDetailsData" :key="index0">
                              <template slot="title">
                                <div class="flex justify-between items-center col-12 p0 mb2">
                                  <div class="flex justify-between items-center mr1">
                                    <img :src="msg.IS_FROM_PARTNER ? msg.PARTNER.AVATAR : msg.CONTACT.AVATAR" class="rounded-circle mr1" alt="avatar" width="50" height="50">
                                    <p class="h5 regular shakespeare m0 line-height-4">{{msg.IS_FROM_PARTNER ? msg.PARTNER.NAME : msg.CONTACT.NAME}}
                                    </p>
                                  </div>
                                  <div>
                                    <p class="regular mediumgrey line-height-1 m0">
                                      <span class="capital">{{moment(msg.SEND_DATE).locale('da').format('LL')}}</span>
                                      {{moment(msg.SEND_DATE).locale('da').format('LL')}}
                                      ({{moment(msg.SEND_DATE).fromNow()}})
                                    </p>
                                  </div>
                                </div>
                              </template>
                              <div class="h6 regular line-height-golden mediumgrey mb2" v-html="msg.MESSAGE"></div>
                              <div v-if="hasAPayProffAccount && msg.ACTIONS && !msg.ACTIONS.IS_DONE">
                                <div :id="'btnAction-' + msg.ID" :class="'mb3 isDone-' + msg.ACTIONS.IS_DONE"
                                  v-if="!msg.IS_FROM_PARTNER">
                                  <!-- eslint-disable -->
                                  <el-tooltip :content="btnAction.ACTION.replaceAll('_', ' ').toUpperCase()" placement="top" effect="light" v-for="(btnAction, index) in msg.ACTIONS.ITEMS" :key="index">
                                    <a type="button" :href="btnAction.DATA" class="action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2 no-underline" v-if="btnAction.ACTION === 'edit_contract'">
                                      <span class=""><i class="el-icon-document"></i></span>
                                    </a>
                                    <a type="button" :href="'#' + btnAction.DATA.split('#')[1]" class="action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2 no-underline" v-else-if="btnAction.ACTION === 'edit_extra_work'">
                                      <span class="">Ny aftale seddel</span>
                                    </a>
                                    <button type="button" class="action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2" @click="submitActionButton(msg.ID, btnAction.ACTION, btnAction.DATA)" v-else>
                                      <span class="" v-if="btnAction.ACTION == 'bank_payment'"><i class="el-icon-bank-card"></i></span>
                                      <span class="" v-else-if="btnAction.ACTION == 'rate_partner'"><i class="el-icon-star-off"></i></span>
                                      <!-- <span class="" v-if="index == 0"><i class="el-icon-download"></i></span>
                                                                <span class="" v-else-if="index == 1"><i class="el-icon-check"></i></span>
                                                                <span class="" v-else-if="index == 2"><i class="el-icon-close"></i></span>
                                                                <span class="" v-else-if="index == 3"><i class="el-icon-edit"></i></span> -->
                                    </button>
                                  </el-tooltip>
                                  <!-- eslint-enable -->
                                </div>
                              </div>
                              <div v-else-if="!hasAPayProffAccount && msg.ACTIONS && !msg.ACTIONS.IS_DONE">
                                <button type="button" class="action-button button-padding border-none not-rounded h5 capital regular line-height-1 py2 px1 mr1 mb2" @click="createPayProfFormVisible = true">
                                  <span class="capitalize">Create Payproff Account</span>
                                </button>
                              </div>
                              <div class="mb3" v-if="msg.FILES.length > 0">
                                <a target="_blank" :href="file" class="block" v-for="(file, index) in msg.FILE" :key="index">{{file.replace($http.options.root.slice(0, -2) + 'upload/partner/messages/', '')}}</a>
                              </div>
                            </el-collapse-item>
                          </el-collapse>
                          <div>
                            <wysiwyg placeholder="Notat" class="mb2" required v-model="replyForm.message" />
                            <button type="button" class="col-12 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1" @click="sendMessage('reply')">
                              <span>Send</span>
                            </button>
                          </div>
                        </div>
                        <div class="center py2" v-else>
                          <span class="h5">Vælg en besked, der skal vises</span>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <el-tab-pane label="Gamle beskeder" name="old">
                  <div class="right-align">
                    <router-link to="/email" class="primarycolor">E-mail</router-link>
                  </div>
                  <div class="py2 inboxSpecial">
                    <b-tabs v-model="tabIndex" pills>
                      <b-tab>
                        <template #title>
                          <span class='el-icon-download mr1' ></span><span class='gibson'>Inbox</span>
                        </template>
                        <div class="messages notosans">
                          <b-alert class="col-12 px0 primarycolor flex justify-start items-center" :show="showDismissibleAlert">
                            <div class="relative" style="top:3px;">
                              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-inbox-f"><path d='M20 5H0l4-5h12l4 5zm0 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h6.126a4.002 4.002 0 0 0 7.748 0H20zM8.265 7h3.465a2 2 0 0 1-3.465 0z' /></svg>
                            </div>
                            <div class="px2">Din indbakke er tom</div>
                          </b-alert>
                          <Message v-for="(email, index) in emails" @showItemDetails="showItemDetails" :email="email" :starMessage="starMessage" :key="index">
                          </Message>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
              </el-tab-pane>
            </el-tabs>
            <div class="my2">
            <el-pagination class="ml-auto" background layout="prev, pager, next" :page-size="perPage" @current-change="paginationChanged" :total="this.totalitems">
            </el-pagination>
            <div class="py4 sm-hide lg-hide xxl-hide"></div>
          </div>
          </div>
        </div>
        <!-- end mobile view -->
      </div>
    </div>
    <b-modal id="inboxMessage" hide-footer size="lg" centered lazy v-model="composeFormVisible" ref="formModal" class="p-2 pb-4" no-close-on-backdrop>
      <div class="col-12 flex justify-end items-center white-background px0 ">
        <button type="button" @click="composeFormVisible = false" class="white-button no-border not-rounded ">
          <span> <i class="el-icon-circle-close"></i> </span>
        </button>
      </div>
      <span class="h5 bold darkblue">Ny besked</span>
      <div class="mb4"></div>
      <div class="clearfix" v-if="formLoading">
        <Loading></Loading>
      </div>
      <form v-else>
        <div class="form-group">
          <el-select v-model="composeForm.to" filterable placeholder="To" class="col-12 p0">
            <el-option key="888888888" label="Info@haandvaerker.dk" :value="1"></el-option>
            <el-option v-for="(item, index) in contactsData" :key="index" :label="item.NAME" :value="item.ID"></el-option>
          </el-select>
          <div v-if="submitted && !composeForm.to" class="red mt1">Nødvendig</div>
        </div>
        <div class="form-group">
          <el-input placeholder="Title" v-model="composeForm.title" class="col-12 p0"></el-input>
          <div v-if="submitted && !composeForm.title" class="red mt1">Nødvendig</div>
        </div>
        <div class="form-group mb4">
          <wysiwyg placeholder="Notat" class="mb2" v-model="composeForm.message" />
          <div v-if="submitted && !composeForm.message" class="red mt1">Nødvendig</div>
        </div>
        <div class="flex justify-end">
          <button type="button"
            class="col-2 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1"
            @click="composeFormVisible = false">
            <span>Luk</span>
          </button>
          <button type="button"
            class="col-2 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1"
            @click="sendMessage('compose')">
            <span>Send</span>
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal hide-footer size="lg" centered lazy v-model="createPayProfFormVisible" ref="formModal" class="p-2 pb-4" no-close-on-backdrop>
      <div slot="modal-header" class="pt2 px0">
        <div class="clearfix">
          <div class="col-12 px2">
            <p class="h4 darkblue gibson line-height-1 semi-bold">
              Skriv til ...
            </p>
          </div>
        </div>
      </div>
      <div></div>
      <span class="h5 bold darkblue">Create Payproff</span>
      <div class="mb4"></div>
      <div class="clearfix" v-if="formLoading">
        <Loading></Loading>
      </div>
      <form @submit.stop.prevent="createPayProff()" v-else>
        <div class="form-group">
          <el-input placeholder="Email" v-model="payProffForm.email" class="col-12 p0" required></el-input>
        </div>
        <div class="form-group">
          <el-input placeholder="Phone" v-model="payProffForm.phoneNumber" class="col-12 p0" required></el-input>
        </div>
        <div class="form-group">
          <el-input placeholder="Phone Area Code" v-model="payProffForm.phoneNumberAreaCode" class="col-12 p0" required>
          </el-input>
        </div>
        <div class="form-group">
          <el-input placeholder="Firstname" v-model="payProffForm.firstName" class="col-12 p0" required></el-input>
        </div>
        <div class="form-group">
          <el-input placeholder="Lastname" v-model="payProffForm.lastName" class="col-12 p0" required></el-input>
        </div>
        <div class="form-group">
          <el-input placeholder="Address" v-model="payProffForm.address" class="col-12 p0" required></el-input>
        </div>
        <div class="form-group">
          <el-input placeholder="Zip" v-model="payProffForm.zipCode" class="col-12 p0" required></el-input>
        </div>
        <div class="form-group">
          <el-input placeholder="City" v-model="payProffForm.city" class="col-12 p0" required></el-input>
        </div>
        <div class="form-group">
          <el-select class="col-12 p0" v-model="payProffForm.country" filterable placeholder="Country"
            autocomplete="new-password" required>
            <el-option v-for="(country, index) in countryData" :key="index" :label="country" :value="index">
            </el-option>
          </el-select>
        </div>
        <div class="form-group">
          <el-input placeholder="Social Security Number" v-model="payProffForm.socialSecurityNumber" class="col-12 p0"
            required></el-input>
        </div>
        <div class="form-group">
          <el-input placeholder="Registration Number" v-model="payProffForm.registrationNumber" class="col-12 p0"
            required></el-input>
        </div>
        <div class="form-group">
          <!-- <el-input type="date" placeholder="Birth Date" v-model="payProffForm.birthDate" class="col-12 p0" required></el-input> -->
          <el-date-picker v-model="payProffForm.birthDate" type="date" placeholder="Birth Date" class="dateSelect"
            required>
          </el-date-picker>
        </div>
        <div class="form-group">
          <el-input placeholder="Account Number" v-model="payProffForm.accountNumber" class="col-12 p0" required>
          </el-input>
        </div>
        <div class="flex justify-end">
          <button type="button"
            class="col-2 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1"
            @click="createPayProfFormVisible = false">
            <span>Luk</span>
          </button>
          <button type="submit"
            class="col-2 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1">
            <span>Send</span>
          </button>
        </div>
      </form>
    </b-modal>
    <b-modal centered lazy v-model="emailShow" size="lg" ref="emailModal">
      <!-- header -->
      <div slot="modal-header" class="w-100 p-2">

      </div>
      <div class="modal-content border-none gibson p1">

        <div class="d-flex flex-column p1">
          <div class="line-height-golden h6 font-weight-bold">
            <template v-if="email.frompid !== '0'" >Til:</template>  {{ email.firstname }} {{ email.lastname }}: {{ email.title }}
          </div>
          <div>
            <span class="far fa-clock text-muted" style="position:relative;top:1px;"></span>
            <small class="text-muted">{{ moment(email.createtime).format('lll') }}</small>
          </div>
        </div>


        <b-embed type="iframe" seamless  :src="'https://www.kundematch.dk/newpartner/readmessage.php?email_id='+email.id+'&id='+salesPerson"  aspect="1by1"   ></b-embed>

      </div>
      <b-row class="mt-4" v-if="email.file.length !== 0">
        <b-col sm="12" md="2" lg="2">
          Files :
        </b-col>
        <b-col sm="12" md="6" lg="6" >
          <ul style="list-style: none;padding: 0;" class="m-t-10">
            <li v-for="(attachment,index) in email.file" class="py-1" :key="index">
              <a :href="'https://www.kundematch.dk/HenttilbudImg.php?img='+attachment" target="_blank" ><i class="el-icon-paperclip"></i> {{attachment.substring(attachment.lastIndexOf('/')+1)}}</a>
            </li>
          </ul>
        </b-col>
      </b-row>
      <!-- modalFooter -->
      <div slot="modal-footer" class="py-4 pl-2 pr-2 d-flex justify-content-end w-100">
        <b-col cols="6" class="pr-0">
          <b-btn type="button" slot="modal-ok" class="rounded float-left" variant="success" size="lg"  @click="resend_service(email)"  :disabled="isLoadingReview">
            <span class="mr2"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 9.062s-5.188-.333-7 1.938c2-4.896 7-5.938 7-5.938v-2l5 4-5 4.019v-2.019zm-18.974 14.938h23.947l-11.973-11.607-11.974 11.607zm1.673-14l10.291-7.488 3.053 2.218c.712-.459 1.391-.805 1.953-1.054l-5.006-3.637-11.99 8.725v12.476l7.352-7.127-5.653-4.113zm15.753 4.892l6.548 6.348v-11.612l-6.548 5.264z"/></svg></span>Reply
          </b-btn>
        </b-col>
        <b-col cols="6" class="pl-0">
          <b-btn type="buttom" slot="modal-cancel" variant="secondary" size="lg" class="float-right rounded" @click="hideModal">
            <i class="el-icon-error mr-2"></i>Luk
          </b-btn>
        </b-col>
      </div>
    </b-modal>
    <b-modal hide-footer size="lg" centered lazy v-model="formShow" ref="formModal" class="p-2 pb-4" no-close-on-backdrop>
      <div slot="modal-header" class="pt2 px0">
        <div class="clearfix">
          <div class="col-12 px2">
            <p class="h4 darkblue gibson line-height-1 semi-bold">
              Skriv til ...
            </p>
          </div>
        </div>
      </div>
      <b-form @submit.stop.prevent="send_service" id="formSubmit">
        <div class="modal-content border-none p2">
          <div class="flex flex-column mb3">
            <div class="h6 semi-bold darkblue mb1">Til:</div>
            <v-select label="name" v-model="to" :options="options" required>
              <template slot="options">
                <span class="h5 darkblue gibson"></span>
              </template>
              <template slot="no-options">
                Ingen matchende ...
              </template>
            </v-select>
          </div>
          <div class="flex flex-column mb3">
            <div class="h6 semi-bold darkblue">Title:</div>
            <b-form-input id="title" v-model="title" class="not-rounded muted-background p2 darkblue h5 gibson border-none" required></b-form-input>
          </div>
          <div class="flex flex-column mb3">
            <div class="h6 semi-bold darkblue mb1">Notat:</div>
            <wysiwyg placeholder="Notat" required v-model="messageinput" />
          </div>
          <div class="form-group">
            <file-upload-input  :token="upload_token" module="quotation" :clear-file="clear_quotation_attachment" @UpdateTilbud="UpdateTilbud" :module-id="tilbud_id"></file-upload-input>
          </div>
        </div>
        <div slot="modal-footer" class="col-12 py3 flex justify-between items-center">
          <button type="reset" @click="hideModalForm" class="standard-button p2 px3 h5 gibson border-none not-rounded justify-start items-center">
            <span></span>
            <span>Luk</span>
          </button>
          <button type="submit" class="action-button p2 px3 gibson h5 not-rounded border-none" :disabled="isLoadingReview">
            <span></span>
            <span class="regular">Send</span>
          </button>
        </div>
      </b-form>
    </b-modal>
    <updatebitrixpackagepermission ref="updatebitrixpackagepermission"></updatebitrixpackagepermission>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>

<script>
import countries from '../../countries.json'
import updatebitrixpackagepermission from '../../../components/updatebitrixpackagepermission'
import Message from '../Message'
import creditchecklist from '../CreditcheckList'
import fileUploadInput from '../../../components/file-upload-input'
import Simplert from 'vue2-simplert'
import vSelect from 'vue-select'
const Loading = () => import('@/components/Loading')
export default {
  components: {
    updatebitrixpackagepermission,
    Message,
    creditchecklist,
    Simplert,
    fileUploadInput,
    vSelect,
    Loading
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.displayMessages()
    this.Reload()
    if (this.$route.query.customerId) {
      this.composeForm.to = Number(this.$route.query.customerId)
      this.composeFormVisible = true
    }
  },
  mounted () {
    this.activeprojectid = this.$route.query.projectId ? this.$route.query.projectId : ''
  },
  data () {
    return {
      totalmessages: 0,
      haaId: '',
      showMobile: false,
      salesPersonBitrix: localStorage.getItem('id_token_portalbitrix'),
      loading: true,
      formLoading: false,
      messageDetailsLoading: false,
      searchQuery: '',
      message: '',
      messagesData: [],
      messageDetailsData: [],
      activeCollapse: [],
      messageDetailsVisible: false,
      composeFormVisible: false,
      composeForm: {
        to: '',
        title: '',
        message: '',
        image: ''
      },
      replyForm: {
        message: '',
        image: ''
      },
      createPayProfFormVisible: false,
      hasAPayProffAccount: false,
      contactsData: [],
      payProffForm: {
        email: localStorage.getItem('email'),
        phoneNumber: localStorage.getItem('PartnerTelefon'),
        phoneNumberAreaCode: '',
        firstName: localStorage.getItem('name').split(' ')[0],
        lastName: localStorage.getItem('name').split(' ')[1],
        address: '',
        zipCode: localStorage.getItem('CompanyZip'),
        city: '',
        country: '',
        socialSecurityNumber: '',
        registrationNumber: '',
        birthDate: ''
        // accountNumber: ''
      },
      countryData: countries,
      sendButtonType: '',
      submitted: '',
      activeName: 'new',
      activeNames: '',
      emails: [],
      sends: [],
      options: [],
      files: [],
      starMessage: '',
      upload_token: '',
      tilbud_id: '',
      salesPerson: '',
      quotation: {
        files: [],
        info: []
      },
      title: '',
      to: '',
      load: 0,
      tabIndex: 0,
      messageinput: '',
      email: { file: [] },
      emailShow: false,
      showDismissibleAlert: false,
      clear_quotation_attachment: false,
      formShow: false,
      isLoadingReview: false,
      overlay: true,
      show: false,
      label: 'Loading...',
      drafts: false,
      activeNameInboxSent: 'inbox',
      lastpage: 0,
      totalitems: 1,
      currentPaginatePage: 1,
      paginationLoading: false,
      perPage: 20,
      activeprojectid: ''
    }
  },
  methods: {
    // login () {
    //   var headers = {
    //     Authorization: 'Bearer ' + this.salesPerson
    //   }
    //   var data = {
    //   }
    //   this.$http.post('https://bitrixapidev.haandvaerker.dk/v1/partner/login/?email=cebu.hvdk@gmail.com&password=CraftTec2021', data, { headers }, { emulateJSON: true }).then(
    //     response => {
    //       var res = response.body.data
    //       this.salesPersonBitrix = res.token
    //       this.displayMessages()
    //     },
    //     response => {
    //       this.$message({
    //         type: 'error',
    //         message: 'An error occured'
    //       })
    //     }
    //   )
    // },
    getContacts () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonBitrix
      }
      var data = {
      }
      this.$http.get(this.$bitrixapi + 'partner/contacts', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.data
          this.contactsData = res.data
          this.submitted = false
          this.messagesLoading = false
          this.formLoading = false
          this.loading = false
        },
        response => {
          this.messagesLoading = false
          this.formLoading = false
          this.loading = false
          // var error = response.body
          // if (error && error.constructor.name !== 'Object') {
          //   if (!error.includes('Unauthorized')) {
          //     if (error.data && error.data !== null) {
          //       for (var message of Object.values(error)) {
          //         this.$message({
          //           type: 'error',
          //           message: message[0]
          //         })
          //       }
          //     } else {
          //       this.$message({
          //         type: 'error',
          //         message: error.message
          //       })
          //     }
          //   } else {
          //     this.$router.push('/login')
          //   }
          // } else {
          //   this.$message({
          //     type: 'error',
          //     message: error.message
          //   })
          // }
        }
      )
    },
    clearFields () {
      this.composeForm.to = ''
      this.composeForm.title = ''
      this.composeForm.message = ''
      this.replyForm.message = ''
    },
    paginationChanged (curPage) {
      this.paginationLoading = true
      this.selectedMessageInfo = {}
      this.currentPaginatePage = curPage
      this.displayMessages()
    },
    displayMessages () {
      this.formLoading = true
      let activeproj = ''
      if (this.$route.query.projectId && !this.$route.query.customerId) {
        activeproj = '&projectId=' + this.$route.query.projectId
      }
      console.log('activeproj', activeproj)
      this.haaId = localStorage.getItem('haaid')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonBitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/messagesV2?sent=false&inbox=true&page=' + this.currentPaginatePage + activeproj, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data.items
          this.lastpage = response.body.data.last_page
          this.totalitems = response.body.data.total
          this.messagesData = res
          this.totalmessages = this.totalitems
          this.perPage = response.body.data.perPage
          this.paginationLoading = false
          this.getContacts()
        },
        response => {
          this.paginationLoading = false
          this.formLoading = false
          this.loading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
        }
      )
    },
    handleToggleInboxSent (tab) {
      if (tab.index === '1') {
        this.$router.push('/messages/sent')
      }
    },
    showoldmessages () {
      this.activeName = 'old'
      this.messageDetailsVisible = false
      this.totalmessages = this.emails.length
      this.messageDetailsData = []
      document.getElementById('searchmessages').classList.add('hide')
      document.querySelector('.el-pagination').classList.add('hide')
    },
    Shownewmessages () {
      this.activeName = 'new'
      this.totalmessages = this.resultQuery.length
      document.getElementById('searchmessages').classList.remove('hide')
      document.querySelector('.el-pagination').classList.remove('hide')
    },
    getMessageDetails (msgId, threadId, clickMessage = {}) {
      this.messageDetailsLoading = true
      var inActiveMsg = document.querySelectorAll('.msgItem')
      for (var x = 0; x < inActiveMsg.length; x++) {
        inActiveMsg[x].classList.remove('active')
      }
      if (!this.showMobile && !this.messageDetailsLoading) {
        var activeMsg = document.querySelector('.msgItem.mail-' + msgId)
        activeMsg.classList.add('active')
      }
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonBitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/messages/' + msgId, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.messageDetailsData = []
          // var filteredMessages = res.filter(function (property) {
          //   return property['IS_FROM_PARTNER'] == true
          // })
          if (threadId === 0) {
            this.messageDetailsData.push(clickMessage)
            this.activeCollapse.push(clickMessage.ID)
          }
          var sortedresponse = res.sort((a, b) => parseFloat(a.ID) - parseFloat(b.ID))
          sortedresponse.forEach(message => {
            this.messageDetailsData.push(message)
            this.activeCollapse.push(message.ID)
          })
          // if (this.messageDetailsData.length > 0) {
          //   this.activeCollapse.push(this.messageDetailsData[sortedresponse.length - 1].ID)
          // }
          // }
          this.validateAccount()
          this.seenMessage(msgId)
          // this.setNewTabInLink()
        },
        response => {
          this.messageDetailsLoading = false
          this.seenMessage(msgId)
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    },
    seenMessage (id) {
      if (document.querySelector('.mail-' + id).classList.contains('seen-0')) {
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonBitrix
        }
        var data = {
        }
        this.$http.put(this.$bitrixapi + 'partner/message/' + id + '/seen', data, { headers }, { emulateJSON: true }).then(
          response => {
          },
          response => {
            this.messageDetailsLoading = false
            var error = response.body
            if (error && error.constructor.name !== 'Object') {
              if (!error.includes('Unauthorized')) {
                if (error.data && error.data !== null) {
                  for (var message of Object.values(error)) {
                    this.$message({
                      type: 'error',
                      message: message[0]
                    })
                  }
                } else {
                  this.$message({
                    type: 'error',
                    message: error.message
                  })
                }
              } else {
                this.$router.push('/login')
              }
            } else {
              this.$message({
                type: 'error',
                message: error.message
              })
            }
          }
        )
        document.querySelector('.mail-' + id + '.seen-0').classList.add('seen-1')
        document.querySelector('.mail-' + id + '.seen-1').classList.remove('seen-0')
      }
    },
    sendMessage (type) {
      this.sendButtonType = type
      this.submitted = true
      var to = ''
      var title = ''
      var message = ''
      // var images = ''
      var url = ''
      var validated = false
      var data = {}
      var msgDetailsLastIndex = this.messageDetailsData.length - 1
      if (type === 'compose') {
        to = this.composeForm.to
        title = this.composeForm.title
        message = this.composeForm.message
        data.contactId = to
        data.title = title
        data.message = message
        // images = this.composeForm.image
        url = 'partner/message'
      } else {
        to = this.messageDetailsData[msgDetailsLastIndex].CONTACT_ID
        title = this.messageDetailsData[msgDetailsLastIndex].TITLE
        message = this.replyForm.message
        data.contactId = to
        data.title = title
        data.message = message
        var messageid = this.messageDetailsData[msgDetailsLastIndex].THREAD_ID !== 0 ? this.messageDetailsData[msgDetailsLastIndex].THREAD_ID : this.messageDetailsData[msgDetailsLastIndex].ID
        // images = this.replyForm.image
        url = 'partner/messages/' + messageid + '/reply'
      }
      if (to && title && message) {
        validated = true
      } else {
        validated = false
      }
      if (validated) {
        if (type === 'compose') {
          this.formLoading = true
        } else {
          this.messageDetailsLoading = true
        }
        // var formData = new FormData()
        // for (var i = 0; i < images.length; i++) {
        //   formData.append('files[' + i + ']', images[i].raw)
        // }
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonBitrix
        }
        this.$http.post(this.$bitrixapi + url, data, { headers }, { emulateJSON: true }).then(
          response => {
            if (type !== 'compose') {
              this.getMessageDetails(this.messageDetailsData[0].ID, this.messageDetailsData[0].THREAD_ID, this.messageDetailsData[0])
            } else {
              this.composeFormVisible = false
            }
            // this.loading = true
            this.clearFields()
            // this.displayMessages()
            this.$message({
              type: 'success',
              message: 'Success'
            })
          },
          response => {
            this.getMessageDetails(this.messageDetailsData[msgDetailsLastIndex].ID, this.messageDetailsData[msgDetailsLastIndex].THREAD_ID)
            this.messageDetailsLoading = false
            this.composeFormVisible = false
            var error = response.body
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        )
      }
    },
    submitActionButton (msgId, action, url) {
      if (action !== 'contract_document_url') {
        document.querySelector('#btnAction-' + msgId).classList.add('hide')
      }
      var msgDetailsLastIndex = this.messageDetailsData.length - 1
      this.messageDetailsLoading = true
      if (action === 'contract_document_url') {
        window.open(url)
        this.messageDetailsLoading = false
      } else {
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonBitrix
        }
        var data = {
        }
        this.$http.post(url, data, { headers }, { emulateJSON: true }).then(
          response => {
            this.getMessageDetails(this.messageDetailsData[msgDetailsLastIndex].ID, this.messageDetailsData[msgDetailsLastIndex].THREAD_ID)
            this.$message({
              type: 'success',
              message: 'Success'
            })
          },
          response => {
            this.messageDetailsLoading = false
            var error = response.body
            if (error && error.constructor.name !== 'Object') {
              if (!error.includes('Unauthorized')) {
                if (error.data && error.data !== null) {
                  for (var message of Object.values(error)) {
                    this.$message({
                      type: 'error',
                      message: message[0]
                    })
                  }
                } else {
                  this.$message({
                    type: 'error',
                    message: error.message
                  })
                }
              } else {
                this.$router.push('/login')
              }
            } else {
              this.$message({
                type: 'error',
                message: error.message
              })
            }
          }
        )
      }
    },
    validateAccount () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonBitrix
      }
      var data = {
      }
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/exists', data, { headers }, { emulateJSON: true }).then(
        response => {
          var res = response.body.data
          this.messageDetailsLoading = false
          this.messageDetailsVisible = true
          setTimeout(() => {
            var msgThread = document.querySelectorAll('.msg-thread')
            var padding = 15
            var totalPadding = 0
            var lastUserId = ''
            var currentUserId = ''
            var deductPadding = false
            for (var i = 0; i < msgThread.length; i++) {
              currentUserId = msgThread[i].id.split('-')[1]
              if (currentUserId !== lastUserId) {
                if (i !== 0) {
                  lastUserId = msgThread[i].id.split('-')[1]
                }
                if (deductPadding) {
                  totalPadding = padding * i - padding
                  deductPadding = false
                } else {
                  totalPadding = padding * i
                }
              } else {
                deductPadding = true
              }
              msgThread[i].style.paddingLeft = totalPadding + 'px'
            }
          }, 50)
          if (res.exists) {
            this.hasAPayProffAccount = true
          } else {
            this.hasAPayProffAccount = false
          }
        },
        response => {
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    },
    createPayProff () {
      this.formLoading = true
      var email = this.payProffForm.email
      var phoneNumber = this.payProffForm.phoneNumber
      var phoneNumberAreaCode = this.payProffForm.phoneNumberAreaCode
      var firstName = this.payProffForm.firstName
      var lastName = this.payProffForm.lastName
      var address = this.payProffForm.address
      var zipCode = this.payProffForm.zipCode
      var city = this.payProffForm.city
      var country = this.payProffForm.country
      var socialSecurityNumber = this.payProffForm.socialSecurityNumber
      var registrationNumber = this.payProffForm.registrationNumber
      var birthDate = this.payProffForm.birthDate
      // var accountNumber = this.payProffForm.accountNumber

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      }
      var data = {
      }
      this.$http.post(this.$http.options.root + '/minbolig/payproff/account?email=' + email + '&phoneNumber=' + phoneNumber + '&phoneNumberAreaCode=' + phoneNumberAreaCode + '&firstName=' + firstName + '&lastName=' + lastName + '&address=' + address + '&zipCode=' + zipCode + '&city=' + city + '&country=' + country + '&socialSecurityNumber=' + socialSecurityNumber + '&birthDate=' + birthDate + '&registrationNumber=' + registrationNumber, data, { headers }, { emulateJSON: true }).then(
        response => {
          this.createPayProfFormVisible = false
          this.formLoading = false
          this.hasAPayProffAccount = true
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        response => {
          this.formLoading = false
          var error = response.body
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                for (var message of Object.values(error)) {
                  this.$message({
                    type: 'error',
                    message: message[0]
                  })
                }
              } else {
                this.$message({
                  type: 'error',
                  message: error.message
                })
              }
            } else {
              this.$router.push('/login')
            }
          } else {
            this.$message({
              type: 'error',
              message: error.message
            })
          }
        }
      )
    },
    seeContract (url) {
      this.$router.push(url)
    },
    handleChange (val) {
      var value = val.split('-')
      this.getMessageDetails(value[0], value[1])
    },
    UpdateTilbud (files) {
      this.files = files
      document.querySelector('#inboxMsg .progress').classList.remove('hide')
    },
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_message', salesPerson: this.salesPerson}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (this.$route.query.send === 'support' && this.load === 0) {
              this.formShow = !this.formShow
            }
            this.emails = res.resultMessage
            this.sends = res.resultSent
            this.options = res.customer
            if (this.$route.query.email) {
              var email
              for (email in this.emails) {
                if (this.emails[email].id === this.$route.query.email && this.load === 0) this.showItemDetails(this.emails[email])
              }
            }
            if (this.$route.query.cid) {
              this.tabIndex = 2
              for (var idc in this.options) {
                var customerList = this.options[idc]
                if (parseInt(customerList.cid) === parseInt(this.$route.query.cid)) {
                  this.to = { 'cid': customerList.cid, 'name': customerList.name }
                }
              }
            }
            if (res.resultMessage.length === 0) this.showDismissibleAlert = true
            if (this.$route.query.default === 'imentor') {
              this.title = 'Nyt abonnement'
              this.message = 'Jeg vil gerne kontaktes ang. et abonnement på Prisberegning.dk'
            }
            if (this.$route.query.default === 'haandvaerker') {
              this.title = 'Nyt abonnement'
              this.message = 'Jeg vil gerne kontaktes ang. et abonnement på Håndværker.dk'
            }
          },
          response => {
            alert('error')
          }
        )
    },
    showItemDetails (email) {
      this.emailShow = !this.emailShow
      this.email = email
      if (this.email.frompid !== '0') return
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_message_read', salesPerson: this.salesPerson, email_id: email.id}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            localStorage.setItem('inbox', res.inbox)
            $('#totalInbox').html(res.inbox)
            if (res.inbox === 0) {
              $('#totalInbox').hide()
            } else {
              $('#totalInbox').show()
            }
          },
          response => {
            alert('error')
          }
        )
    },
    send_service (evt) {
      if (!this.to.cid) return
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'send_service', salesPerson: this.salesPerson, title: this.title, message: this.message, to: this.to.cid, files: JSON.stringify(this.files)}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.load = 1
              this.Reload()
              this.formShow = false
              this.title = ''
              this.message = ''
              this.files = []
              this.tabIndex = 0
              document.querySelector('#inboxMsg .progress').classList.add('hide')
              var fileList = document.querySelectorAll('#inboxMsg .upload-file-list li')
              for (var i = 0; i < fileList.length; i++) {
                fileList[i].remove()
                console.log(fileList[i])
              }
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    resend_service (email) {
      this.$refs.emailModal.hide()
      this.formShow = !this.formShow
      this.title = 'Re: ' + email.title
      console.log(email.cid + 'hgggg')
      for (var idc in this.options) {
        var customerList = this.options[idc]
        if (parseInt(customerList.cid) === parseInt(email.cid)) {
          this.to = { 'cid': customerList.cid, 'name': customerList.name }
        }
      }
    },
    mailSupport () {
      this.formShow = !this.formShow
    },
    hideModal () {
      this.$refs.emailModal.hide()
    },
    hideModalForm () {
      this.$refs.formModal.hide()
    }
  },
  computed: {
    resultQuery () {
      if (this.searchQuery) {
        return this.messagesData.filter((msg) => {
          return this.searchQuery.toLowerCase().split(' ').every(v => msg.TITLE.toLowerCase().includes(v))
        })
      } else {
        return this.messagesData
      }
    }
  }
}
</script>
<style>
#oldmessagestoggle .el-tabs__header {
  display: none!important;
}
.msgItem.seen-1,
.msgItem.seen-1 .h4,
.msgItem.seen-1 .h5,
.msgItem.fromPartner-true,
.msgItem.fromPartner-true .h4,
.msgItem.fromPartner-true .h5 {
  border-color: rgb(47 54 64 / 11%) !important;
  color: rgba(47, 54, 64, 0.5) !important;
}

/*  div .msgItem.fromPartner-true .h4 {
    color: rgba(47, 54, 64, 0.5) !important;
  } */
.dateSelect.el-input {
  width: 100%;
}

.dateSelect .el-input__inner {
  width: 100%;
}

p.msg>p {
  margin-bottom: 0;
}
#messages button {
  -webkit-appearance: none!important;;
}
#messages .el-collapse {
  border: none;
}

#messages .msg-thread .el-collapse-item__header {
  background-color: #fff;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(71, 196, 204, 0.2);
}

#messages .msg-thread .el-collapse-item__header.is-active {
  border-bottom-color: transparent;
}

#messages .el-collapse-item__content {
  padding-bottom: 0;
}

#messages .el-collapse-item__arrow {
  display: none;
}

#messages .el-collapse-item:last-child .el-collapse-item__header {
  border-bottom: none;
}

#messages .el-collapse-item__wrap {
  border-bottom-color: rgba(71, 196, 204, 0.2) !important;
}

#messages .el-collapse-item:last-child .el-collapse-item__wrap {
  border-bottom: none;
}

#messages .msgItem.active {
  background-color: rgb(71 196 204 / 10%);
}

#inboxMessage .modal-content .modal-body {
  padding: 15px;
}

#inboxMessage a.vw-btn-image {
  display: none;
}
@media (max-width: 42em) {
  .messageavatar {
    width: 30px;
    height: 30px;
  }
  #messages .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    min-width: 20px;
  }
  #messages .el-tabs__header {
    display: none!important;
  }
}
</style>


// WEBPACK FOOTER //
// inbox.vue?5bdb4b11